import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import ImportServices from '@root/modules/Sellers/Import/services/import';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import DropdownButton from '../../Inquiry/components/DropdownButton';
import SearchBox from '../../Inquiry/components/Search';
import BreadcrumbList from '../../Stock/components/Breadcrumb';

interface DataType {
  key: React.Key;
  productName: string;
  SSKU: number;
  centerName: number;
  status: number;
  progressStatus?: string;
  updateDate: Date;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const ImportManagement = () => {
  const [t] = useTranslate();
  const history = useHistory();
  const [list, setList] = useState([] as any);
  const [listExcel, setListExcel] = useState([] as any);
  const [totalItem, setTotaItem] = useState();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [status, setStatus] = useState('');
  const [labelStatus, setLabelStatus] = useState({
    key: '1',
    label: t('seller:button:select')
  } as any);
  const [valueStatus, setValueStatus] = useState('');
  const debounc = useDebounce(valueStatus, 1000);
  const [sort, setSort] = useState(true);
  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';

  const [isSearch, setIsSearch] = useState('');

  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const getStatus = (e: any) => {
    setStatus(e.key);
    setLabelStatus({ key: e.key, label: e.domEvent.target.innerText });
  };

  const onChangeState = (name: string, value: string) => {
    setValueStatus(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };

  const columns: ColumnsType<DataType> = [
    {
      title: '입고 번호',
      dataIndex: 'key'
    },
    {
      title: t('table:seller:product-name'),
      dataIndex: 'productName'
    },
    {
      title: 'SKU',
      dataIndex: 'SSKU'
    },
    {
      title: t('table:seller:logistic-center'),
      dataIndex: 'centerName'
    },
    {
      title: t('table:content:status'),
      dataIndex: 'status'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {t('table:seller:update')}
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updateDate'
    }
  ];

  const Breadcrumb = [
    {
      tittle: '입고 관리 ',
      url: ''
    },
    {
      tittle: '입고 조회',
      url: ''
    }
  ];

  const listLabel = [
    {
      id: 2,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: '입고요청',
              key: 'request'
            },
            {
              type: 'divider'
            },
            {
              label: '입고승인',
              key: 'approved'
            },
            {
              type: 'divider'
            },
            {
              label: '입고완료',
              key: 'delivered'
            }
          ]}
        />
      )
    },
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getStatus}
          items={[
            {
              label: '상품명',
              key: 'productName'
            },
            {
              type: 'divider'
            },
            {
              label: '물류센터명',
              key: 'warehouseName'
            },
            {
              type: 'divider'
            },
            {
              label: 'SKU',
              key: 'sku'
            }
          ]}
        />
      )
    }
  ];
  const onSelectChange = (newlistExcel: React.Key[]) => {
    setListExcel(newlistExcel);
  };

  const rowSelection = {
    listExcel,
    onChange: onSelectChange
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY/MM/DD';

  const idMap = listExcel.map((item: React.Key) => item);

  const arrId = {
    ids: idMap
  };

  const listStatus = [
    {
      code: 'Request To Import',
      name: '입고요청'
    },
    {
      code: 'Import Completed',
      name: '입고완료'
    },
    {
      code: 'Approved',
      name: '입고승인'
    }
  ];
  const getPagination = async (
    page: number,
    valueSearch: string,
    productName: string,
    sort: boolean,
    proName: string,
    fromDt: string,
    toDt: string
  ) => {
    setLoading(true);
    const temp = await ImportServices.getListImport({
      page,
      productName,
      sort,
      fromDt,
      toDt,
      valueSearch,
      proName
    });
    let listImport: any[] = [];
    temp.data.forEach((element: any) => {
      return element.quotation.products.forEach((item: any, index: number) => {
        if (index !== 0) {
          return;
        }
        listImport.push({
          key: element.id,
          SSKU: item.sku,
          eanUpc: item.eanUpc,
          stockQuantity: item.stockQuantity,
          updateDate: formatDateTime(element.updated_at),
          productName: item.productName,
          updateAtSort: item.updated_at,
          centerName: element.quotation.warehouse.name,
          status: listStatus.find((x) => x.code === element.impStatus)?.name
        });
      });
    });
    setList(listImport);
    setTotaItem(temp.meta.totalItems);
    setCurrentPage(temp.meta.currentPage);
    setLoading(false);
  };

  useEffect(() => {
    if (!!valueStatus && !!status) setIsSearch(valueStatus);
    else if (!!isSearch && !valueStatus) {
      setIsSearch('');
    }
  }, [debounc, status]);

  useEffect(() => {
    getPagination(1, valueStatus, proName, sort, status, fromDt, toDt);
  }, [isSearch, proName, sort, fromDt, toDt]);

  const handelExportExcel = async () => {
    if (listExcel.length > 0) {
      const responseById = await ImportServices.exportExcelById(arrId);
      const outputFilename = `Inquiry_240406T9g6QGJSxyR.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const productName = proName;
      const valueSearch = valueStatus;
      const response = await ImportServices.exportExcelAll({
        productName,
        sort,
        fromDt,
        toDt,
        valueSearch
      });
      const outputFilename = `Inquiry_240406T9g6QGJSxyR.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>

          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={item.id === 1 ? labelStatus.label : labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>
                    총 입고
                    {totalItem}
                  </span>
                  <span className="table__head --right">
                    선택 입고
                    {listExcel.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={() => {
                      handelExportExcel();
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                rowSelection={rowSelection}
                pagination={{
                  total: totalItem,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      valueStatus,
                      proName,
                      sort,
                      status,
                      fromDt,
                      toDt
                    );
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/import/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ImportManagement;
